(function () {
    function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }

    function handleCompareVisibility(section, event) {
        section.querySelectorAll('.compare-group--wrapper').forEach(group => {
            group.classList.add('component--hidden');
        });

        const selectedGroup = section.querySelector(`.compare-group--wrapper[data-compare-id="${event.target.value}"]`);
        if (selectedGroup) {
            selectedGroup.classList.remove('component--hidden');

            const handle = selectedGroup.querySelector('.compare-slider--handle');
            const revealImage = selectedGroup.querySelector('.reveal--image');
            revealImage.style.clipPath = `inset(0 50% 0 0)`;
            handle.style.left = `50%`;
        }
    }

    function animateSlider(animationDuration, handle, revealImage, section, loop = false, endAt50 = false, resume = false) {
        if (!loop && section.dataset.animated === "true") return;
        let startTime;
        const duration = animationDuration;
        const keyframes = endAt50 ? [100, 0, 50] : [100, 0, 100]; // Loop unless `endAt50` is true
        let frameIndex = resume ? 1 : 0; // If resuming, start from mid-point

        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            const elapsed = timestamp - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const easedProgress = easeInOutCubic(progress);

            const startValue = keyframes[frameIndex];
            const endValue = keyframes[frameIndex + 1];
            const value = startValue + (endValue - startValue) * easedProgress;

            revealImage.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
            handle.style.left = `${value}%`;

            if (progress < 1) {
                requestAnimationFrame(step);
            } else if (frameIndex < keyframes.length - 2) {
                frameIndex++;
                startTime = null;
                requestAnimationFrame(step);
            } else if (loop) {
                frameIndex = 0;
                startTime = null;
                requestAnimationFrame(step);
            } else {
                section.dataset.animated = "true";
            }
        }

        requestAnimationFrame(step);
    }

    function updateSliderPosition(e, component, handle, revealImage) {
        const container = component.querySelector('.compare-image--wrapper');
        if (!container.contains(e.target)) return;

        const containerRect = container.getBoundingClientRect();
        let offsetX = e.touches ? e.touches[0].clientX - containerRect.left : e.clientX - containerRect.left;

        offsetX = Math.max(0, Math.min(offsetX, containerRect.width));

        const percentage = (offsetX / containerRect.width) * 100;

        revealImage.style.clipPath = `inset(0 ${100 - percentage}% 0 0)`;
        handle.style.left = `${percentage}%`;
    }

    function startDragging(e, component, handle, revealImage) {
        updateSliderPosition(e, component, handle, revealImage);

        function dragMove(event) {
            updateSliderPosition(event, component, handle, revealImage);
        }

        function dragEnd() {
            const parent = component.closest('.compare-groups--parent');
            const interactionType = parent.getAttribute('data-interaction-type');

            window.removeEventListener('mousemove', dragMove);
            window.removeEventListener('mouseup', dragEnd);

            if (interactionType === "continuous_interactive") {
                requestAnimationFrame(() => animateSlider(3500, handle, revealImage, parent, true, false, true));
            }
        }

        window.addEventListener('mousemove', dragMove);
        window.addEventListener('mouseup', dragEnd);
    }

    function initCompareComponent(component) {
        if (component.dataset.initialized === "true") return;
        component.dataset.initialized = "true";

        const handle = component.querySelector('.compare-slider--handle');
        const revealImage = component.querySelector('.reveal--image');
        const section = component.closest('section');
        const parent = component.closest('.compare-groups--parent');
        const interactionType = parent.getAttribute('data-interaction-type');
        const animationDuration = parent.getAttribute('data-animation-duration')
            ? parseInt(parent.getAttribute('data-animation-duration'))
            : 3500;
        const selector = section.querySelector('[data-content="compare-option-select"]');
        if (selector) {
            selector.addEventListener('change', (event) => {
                handleCompareVisibility(section, event);
            });
        }

        if (interactionType === "continuous") {
            animateSlider(animationDuration, handle, revealImage, section, true);
            return;
        } else if (interactionType === "continuous_interactive") {
            animateSlider(animationDuration, handle, revealImage, section, true);
        } else if (interactionType === "first_view") {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            animateSlider(animationDuration,handle, revealImage, section, false, true);
                            observer.unobserve(component);
                        }
                    });
                },
                { threshold: 0.5 }
            );
            observer.observe(component);
        }

        const imageWrapper = component.querySelector('.compare-image--wrapper');

        if (interactionType !== "continuous") {
            imageWrapper.addEventListener('mousedown', (event) => {
                startDragging(event, component, handle, revealImage);
            });

            imageWrapper.addEventListener('touchstart', (event) => {
                event.preventDefault();
                startDragging(event, component, handle, revealImage);
            });

            imageWrapper.addEventListener('touchmove', (event) => {
                event.preventDefault();
                updateSliderPosition(event, component, handle, revealImage);
            });

            imageWrapper.addEventListener('touchend', () => {
                window.removeEventListener('mousemove', updateSliderPosition);
            });
        }
    }

    function initCompareSections() {
        document.querySelectorAll('[data-content="compare-component"]').forEach(initCompareComponent);
    }

    document.addEventListener('DOMContentLoaded', initCompareSections);

    if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', initCompareSections);
        document.addEventListener('shopify:section:unload', initCompareSections);
        document.addEventListener('shopify:section:select', initCompareSections);
        document.addEventListener('shopify:section:deselect', initCompareSections);
        document.addEventListener('shopify:section:reorder', initCompareSections);
    }
})();
